<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { AmbientFabricBackground, UiLogo } from '@shopexperts/shared';
import ClientSignupForm from '../components/ClientSignupForm.vue';
import type { RegisterAuthResult } from '../components/leads/RegisterForm.vue';

import { getSafeClientRedirect } from '@/app/utils/directReview';

const router = useRouter();
const route = useRoute();

// Using a placeholder image - replace with actual image path
const centeredImage = 'https://cdn.shopexperts.com/media/public/leads-form%402.png';

function handleAuthenticated(_data: RegisterAuthResult) {
    router.push(getSafeClientRedirect(2, route.query.redirect) || '/client/overview');
}
</script>

<template>
    <div class="min-h-screen w-screen bg-white">
        <div class="flex flex-col md:flex-row w-full h-screen">
            <!-- First Column: Form Content (35% width, min-width for mobile) -->
            <div class="w-full md:w-[35%] min-w-[320px] flex flex-col h-screen overflow-y-auto">
                <div class="flex flex-col gap-8 p-6 md:p-8">
                    <!-- Header with Logo -->
                    <header class="flex items-center">
                        <UiLogo size="md" />
                    </header>

                    <!-- Client Signup Form Component -->
                    <ClientSignupForm @authenticated="handleAuthenticated" />
                </div>
            </div>

            <!-- Second Column: Ambient Background with Image (hidden on mobile) -->
            <div class="hidden md:flex flex-1 h-screen relative">
                <AmbientFabricBackground :settings="{ class: 'w-full h-full' }">
                    <div class="flex items-center justify-center h-full px-17 py-30">
                        <img 
                            :src="centeredImage" 
                            alt="Signup Visual" 
                            class="w-full h-auto max-h-full object-contain"
                        />
                    </div>
                </AmbientFabricBackground>
            </div>
        </div>
    </div>
</template>

